// Pure date/string formatters for the Report modal.
// No React, no DOM, no external imports — safe to unit-test in isolation.

// Citation-quote truncation, shared across criteria and reasons rendering.
// Visible text capped at ~100 chars; full verbatim quote shown on hover via title.
export function truncQuote(q) {
  if (!q) return "";
  return q.length > 100 ? q.slice(0, 100).trimEnd() + "..." : q;
}

// M/D/YY date formatter for the report metadata rows.
//
// A date-only "YYYY-MM-DD" string is parsed as LOCAL midnight, not UTC midnight.
// `new Date("2026-07-28")` is UTC midnight, which in any timezone west of UTC
// renders as the PREVIOUS day — the RESOLVED ON chip showed "7/27/26" for a
// resolution_date of 2026-07-28, contradicting the modal's own header. A bare
// date carries no timezone, so it must render as that calendar date everywhere.
// Same convention as parseResolveDateLocal / fmtResolveDate in lib/formatDates.js.
export function fmtMDY(d) {
  if (!d) return "—";
  const dt = new Date(typeof d === "string" && d.length === 10 ? d + "T00:00:00" : d);
  if (isNaN(dt.getTime())) return d;
  return `${dt.getMonth() + 1}/${dt.getDate()}/${String(dt.getFullYear()).slice(-2)}`;
}

// M/D/YY h:mm AM/PM formatter — used for the FORECAST DATE row in
// both the visible body and the PDF/DOCX export block. The plain
// date format above is kept for fields like RESOLUTION DATE where
// time-of-day is irrelevant.
export function fmtMDYTime(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return d;
  const h12 = ((dt.getHours() + 11) % 12) + 1;
  const mm = String(dt.getMinutes()).padStart(2, "0");
  const ampm = dt.getHours() < 12 ? "AM" : "PM";
  return `${dt.getMonth() + 1}/${dt.getDate()}/${String(dt.getFullYear()).slice(-2)} ${h12}:${mm} ${ampm}`;
}
